import { ADD_TICKET, APPEND_TICKET, ADD_TICKETS_COUNT, APPEND_TICKETS_COUNT, REDUCE_TICKETS_COUNT, REMOVE_TICKET } from '../actionsList';

const initialSettings = {
    object: {},
    count: { user: 0, partner: 0, total: 0 },
};

const ticketingReducer = (state = initialSettings, action) => {
    switch (action.type) {
        case ADD_TICKET: {
            return {
                ...state,
            }
        }
        case APPEND_TICKET: {
            let object = { ...state.object }
            object[action.info.ticketReply._id] = JSON.parse(JSON.stringify(action.info))
            console.log('objectssss', object)
            return {
                ...state,
                object
            }
        }
        case REMOVE_TICKET: {
            let object = { ...state.object }
            console.log('removeTicket',action.info.id)
            delete object[action.info.id]
            return {
                ...state,
                object
            }
        }
        case ADD_TICKETS_COUNT: {
            let count = { ...action.info }

            // console.log('action.info999', action.info)
            return {
                ...state,
                count
            }
        }
        case APPEND_TICKETS_COUNT: {
            let count = state.count
            count += 1
            // console.log('action.info', action.info)
            return {
                ...state,
                count
            }
        }
        case REDUCE_TICKETS_COUNT: {
            let count = state.count
            count = count - 1
            return {
                ...state,
                count
            }
        }
        default:
            return state;
    }
}






export default ticketingReducer;